import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["indicator"]

  connect() {
    console.log("turbo_spinner#connect")
    this.element.addEventListener("turbo:submit-start", this.show.bind(this))
    this.element.addEventListener("turbo:submit-end", this.hide.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.show)
    this.element.removeEventListener("turbo:submit-end", this.hide)
  }

  show() {
    console.log("turbo_spinner#show")
    this.indicatorTarget.classList.remove("d-none")
  }

  hide() {
    console.log("turbo_spinner#hide")
    this.indicatorTarget.classList.add("d-none")
  }
}
